module.exports = __webpack_public_path__ + "img/Joaquin.ac5cde45.jpg";